import feathersClient, {
  makeServicePlugin,
  BaseModel
} from '@/plugins/feathersClient';

class Utm extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'Utm';

  // Define default properties here
  static instanceDefaults() {
    return {
      source: '',
      medium: '',
      campaign: '',
      term: '',
      content: '',
      fullLink: ''
    };
  }
}
const servicePath = 'utm';
const servicePlugin = makeServicePlugin({
  Model: Utm,
  service: feathersClient.service(servicePath),
  servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
});

export default servicePlugin;
